export default {
	getCurrentEvent(state) {
		return state.currentEvent;
	}
};
